export default __webpack_public_path__ + "static/media/RocketLaunch.f1128bdb.svg";